import React from "react";
import { ReactSortable } from "react-sortablejs";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import Tag from "./Tag";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexWrap: "wrap",
      gap: "5px",
      justifyContent: "flex-start",
      marginBottom: "20px",
      maxHeight: "150px",
      overflowY: "auto",
    },
  });

const Tags = (props: any) => {
  const {
    datas,
    setTags,
    onRemoveTag,
    classes,
    currentTag,
    originalTags,
  } = props;

  const originalNames = new Set(
    (originalTags || []).map((t: any) => t.name),
  );

  /**
   * Function to remove a tag from the list or reset it if it already exists
   * @param item tag to remove
   * @param index index in the array of tags
   * @returns the tag before it is modified to be able to reset it
   */
  const handleRemoveTag = (item: any, index: number) => {
    if (index < originalTags.length) {
      const nextDatas = datas.map((t: any, i: number) =>
        i === index ? { ...t, name: originalTags[index].name } : t,
      );
      setTags(nextDatas);
      return originalTags[index].name;
    } else {
      onRemoveTag && onRemoveTag(item.id, item.name);
      return item.name;
    }
  };

  return (
    <ReactSortable
      list={datas}
      setList={setTags}
      animation={150}
      className={classes.root}
    >
      {datas.map((item: any, index: number) => (
        <Tag
          key={index}
          item={{ ...item, original: index < originalTags.length }}
          label={item.name}
          shake={item.name === currentTag}
          editable
          onDelete={() => handleRemoveTag(item, index)}
          withDelete={!originalNames.has(item.name)}
          onValidateChange={(value: string) => {
            if (
              value !== "" &&
              !datas.find((d: any) => d.name === value)
            ) {
              const nextDatas = datas.map((t: any, i: number) =>
                i === index ? { ...t, name: value } : t,
              );
              setTags(nextDatas);
            }
          }}
        />
      ))}
    </ReactSortable>
  );
};

export default withStyles(styles)(Tags);
